import { useEffect } from 'react';

export const useExternalCSS = (url: string): void => {
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `@import url(${url})`;
    document.head.appendChild(style);
  }, [url]);
};
